import React from 'react'
import { IllustrationError, Header } from '@bbl-digital/snorre'
import { ERROR_NO_PAGE_FOUND } from 'shared/constants/errorMessages'
import { Wrapper as ErrorWrapper } from './styles'

const NoPageError: React.FC = () => {
  return (
    <ErrorWrapper>
      <IllustrationError />
      <Header level={2}>{ERROR_NO_PAGE_FOUND}</Header>
    </ErrorWrapper>
  )
}

export { ErrorWrapper, NoPageError }
export default NoPageError
